import Select from 'features/common/components/Select'
import {useTranslation} from 'react-i18next'
import {Sort} from '../../../../../common/core/entities/sort'

const sortOptions = [
    {value: 'name', label: 'QR_SORT_BY_NAME'},
    {value: 'rating', label: 'QR_SORT_RATING'},
    {value: 'tip', label: 'QR_SORT_TIPS_AMOUNT'},
    {value: 'experience', label: 'QR_SORT_EXPERIENCE'},
] as const

type SortSelectProps = {
    sortBy: Sort | null
    onSort: (s: Sort) => void
}

const SortSelect = ({sortBy, onSort}: SortSelectProps) => {
    const {t} = useTranslation()

    const chosenSortOption = sortOptions.find((so) => so.value === sortBy)

    return (
        <Select
            value={sortBy}
            onChange={(value: Sort) => value && onSort(value)}
        >
            <Select.Button className="h-10">
                {chosenSortOption ? (
                    t(chosenSortOption.label)
                ) : (
                    <div className="text-grey-20">
                        {t('QR_SORT_PLACEHOLDER')}
                    </div>
                )}
            </Select.Button>
            <Select.Options>
                {sortOptions.map((op) =>
                    op.value !== sortBy ? (
                        <Select.Option
                            className="h-10"
                            key={op.value}
                            value={op.value}
                        >
                            {t(op.label)}
                        </Select.Option>
                    ) : null,
                )}
            </Select.Options>
        </Select>
    )
}

export default SortSelect
